import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    legacy: {
      type: Boolean,
      default: false,
    },
  }

  selectContractType(event) {
    const target = event.target
    const selectedOption = target.selectedOptions[0]
    const optGroup = selectedOption.closest('optgroup')
    const isLegacy = optGroup.dataset.legacy === 'true'
    const selectedType = event.target.value

    const originalLocation = window.location.pathname

    if (isLegacy && !this.legacyValue) {
      event.stopPropagation()
      window.location.href =
        originalLocation.replace('billing_contracts', 'contracts') +
        `?contract_type=${selectedType}`
      this.element.disabled = true
    } else if (!isLegacy && this.legacyValue) {
      event.stopPropagation()
      window.location.href = originalLocation.replace(
        'contracts',
        'billing_contracts',
      )
      this.element.disabled = true
    }
  }
}
